<template>
  <b-container class="contentcontainer">
    <b-row class="contentcontainer__head">
      <b-col>
        <h2>{{$t('user.payment.viewtitle')}}</h2>
      </b-col>
    </b-row>
    <hr/>
    <b-row>
      <b-col>
        <div v-if="validPayment">
          <h3>{{$t('user.payment.validpaymenttitle')}}</h3>
          <p>{{$t('user.payment.validpayment')}}</p>
          <div class="table-responsive-lg">
            <table class="table table--overview">
              <thead>
                <tr>
                  <th>
                    {{$t('user.payment.type')}}
                  </th>
                  <th>
                    {{$t('user.payment.last4')}}
                  </th>
                  <th>
                    {{$t('user.payment.actions')}}
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr v-if="account.default_payment_method == 'CC' && validCreditCard">
                  <td>
                    {{$t('user.payment.creditcard')}}
                  </td>
                  <td>
                    {{account.cc_last4}}
                  </td>
                  <td>
                    <button class="add-credit-card btn btn--primary" @click="addCreditCard()">{{$t('user.payment.updatecard')}}</button>
                  </td>
                </tr>

                <tr v-if="account.default_payment_method == 'SEPA' && validSepa">
                  <td>
                    {{$t('user.payment.bankaccount')}}
                  </td>
                  <td>
                    {{account.sepa_last4}}
                  </td>
                  <td>
                    <button class="add-credit-card btn btn--primary" @click="addSepa()">{{$t('user.payment.updatesepa')}}</button>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>

          <div v-if="sepaAllowed && !validSepa">
            <p>{{$t('user.payment.sepaallowed')}}</p>
            <p>
              <button class="add-credit-card btn btn--primary" @click="addSepa()">{{$t('user.payment.addsepa')}}</button>
            </p>
          </div>
        </div>
        <div v-else>
          <h3>{{$t('user.payment.nopaymentinformationtitle')}}<br></h3>
          <p>{{$t('user.payment.nopaymenttext')}}</p>
          <p v-html="$t('user.payment.nocreditcard')"></p>
          <p>
            <button class="add-credit-card btn btn--primary" @click="addCreditCard()">{{$t('user.payment.addcreditcard')}}</button>
          </p>
          <div v-if="sepaAllowed">
            <p>{{$t('user.payment.sepaallowed')}}</p>
            <p>
              <button class="add-credit-card btn btn--primary" @click="addSepa()">{{$t('user.payment.addsepa')}}</button>
            </p>
          </div>
        </div>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import { mapGetters } from 'vuex'

export default {

  name: 'payment',

  computed: {

    ...mapGetters('user', {
      user: 'getUser',
      account: 'getAccount'
    }),

    validPayment () {
      return this.account.valid_payment
    },

    sepaAllowed () {
      return this.account.sepa_payment_allowed
    },

    validCreditCard () {
      return this.account.valid_cc_payment
    },

    validSepa () {
      return this.account.valid_sepa_payment
    }
  },

  methods: {

    addCreditCard () {
      this.$router.push({
        name: 'addCard',
        params: {
          id: 0
        }
      })
    },

    addSepa () {
      this.$router.push({
        name: 'addSepa',
        params: {
          id: 0
        }
      })
    }
  }
}
</script>
